import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
/**
 * Reusable loading spinner component
 */
const LoadingSpinner = ({ size = 'md', text, className = '', fullScreen = false }) => {
    const sizeClasses = {
        sm: 'h-4 w-4',
        md: 'h-8 w-8',
        lg: 'h-12 w-12'
    };
    const spinner = (_jsxs("div", { className: `flex flex-col items-center justify-center gap-3 ${className}`, children: [_jsx(Loader2, { className: `${sizeClasses[size]} animate-spin text-primary` }), text && (_jsx("p", { className: "text-sm text-muted-foreground animate-pulse", children: text }))] }));
    if (fullScreen) {
        return (_jsx("div", { className: "fixed inset-0 bg-background/90 flex items-center justify-center z-50", children: spinner }));
    }
    return spinner;
};
export default LoadingSpinner;
